import { useParams } from 'react-router-dom'

import { ResidentAppError } from '../../../common/error'

export const useCurrentQuestionNotice = () => {
  const { feedbackQuestionNoticeUuid } = useParams()

  if (!feedbackQuestionNoticeUuid) {
    throw ResidentAppError.ClientError('NOT_FOUND', {
      message: 'No feedbackQuestionNoticeUuid found in params',
    })
  }

  return {
    currentQuestionNoticeUuid: feedbackQuestionNoticeUuid,
  }
}
